const routerView = {
  template: '<router-view></router-view>'
};

function getBrandIdentifier(route) {
  return { brandIdentifier: Number(route.query.brandIdentifier) };
}
export default [
  {
    name: 'dashboard',
    path: '/dashboard',
    meta: {
      title: '대시보드'
    },
    component: () => import(/* webpackChunkName: "Dashboard" */ '@/views/workplace/dashboard/Dashboard') // 대시보드
  },
  {
    name: 'report',
    meta: {
      title: '분석'
    },
    path: '',
    component: routerView,
    children: [
      // 티켓분석
      {
        name: 'ticket_dashboard',
        path: '/ticket/dashboard',
        meta: {
          title: '티켓 대시보드'
        },
        component: () => import(/* webpackChunkName: "TicketDashboard" */ '@/views/workplace/counselAnalysis/ticket/TicketDashboard') // 분석 -> 티켓분석 -> 티켓 대시보드
      },
      {
        name: 'ticket_statistics',
        path: '/ticket/statistics',
        meta: {
          title: '티켓 통계'
        },
        component: () => import(/* webpackChunkName: "TicketStatistics" */ '@/views/workplace/counselAnalysis/ticket/TicketStatistics') // 분석 -> 티켓분석 -> 티켓 통계
      },
      // 상담 분석
      {
        name: 'ConsultStatus',
        path: '/report/consult_status',
        meta: {
          title: '상담 현황'
        },
        component: () => import(/* webpackChunkName: "ConsultStatus" */ '@/views/workplace/counselAnalysis/talkConsult/ConsultStatus') // 분석 -> 상담 분석 -> 상담 현황
      },
      {
        name: 'ConsultStatististics',
        path: '/report/consult_statistics',
        meta: {
          title: '상담 통계'
        },
        component: () => import(/* webpackChunkName: "ConsultStatistics" */ '@/views/workplace/counselAnalysis/talkConsult/ConsultStatististics') // 분석 -> 상담 분석 -> 상담 통계
      },
      {
        name: 'brand_chat_list',
        path: '/report/consult_history',
        meta: {
          title: '상담 내역'
        },
        component: () => import(/* webpackChunkName: "ConsultHistory" */ '@/views/workplace/counselAnalysis/talkConsult/ConsultHistory') // 분석 -> 상담 분석 -> 상담 내역
      },
      {
        name: 'brand_agent_delay_status',
        path: '/report/delay_status',
        meta: {
          title: '상담사 지연 현황'
        },
        component: () => import(/* webpackChunkName: "DelayStatus" */ '@/views/workplace/counselAnalysis/talkConsult/DelayStatus') // 분석 -> 상담 분석 -> 상담사 지연 현황
      },
      // 메시지 분석
      {
        name: 'send_statistics',
        path: '/message/send_statistics',
        meta: {
          title: '메시지 통계'
        },
        component: () => import(/* webpackChunkName: "SendStatistics" */ '@/views/workplace/counselAnalysis//message/SendStatistics') // 분석 -> 메시지 분석 -> 메시지 통계
      },
      // 콜 상담 분석
      {
        name: 'call_status',
        path: '/report/call_status',
        meta: {
          title: '상담 현황'
        },
        component: () => import(/* webpackChunkName: "CallConsultStatus" */ '@/views/workplace/counselAnalysis/call/CallConsultStatus') // 분석 -> 콜 상담 분석 -> 상담 현황(KT 계정일 경우 노출)
      },
      {
        name: 'call_statistics',
        path: '/report/call_statistics',
        meta: {
          title: '상담 통계'
        },
        component: () => import(/* webpackChunkName: "CallConsultStatistics" */ '@/views/workplace/counselAnalysis/call/CallConsultStatistics') // 분석 -> 콜 상담 분석 -> 상담 통계(KT 계정일 경우 노출)
      },
      {
        name: 'call_history',
        path: '/report/call_history',
        meta: {
          title: '상담 이력'
        },
        component: () => import(/* webpackChunkName: "CallConsultHistory" */ '@/views/workplace/counselAnalysis/call/CallConsultHistory') // 분석 -> 콜 상담 분석 -> 상담 이력(KT 계정일 경우 노출)
      },
      {
        name: 'call_history_status',
        path: '/report/call_history_status',
        meta: {
          title: '상담콜 이력 현황'
        },
        component: () => import(/* webpackChunkName: "CallHistoryStatus" */ '@/views/workplace/counselAnalysis/call/CallHistoryStatus') // 분석 -> 콜 상담 분석 -> 상담콜 이력 현황(KT 계정일 경우 노출)
      },
      {
        name: 'call_service_level',
        path: '/report/call_service_level',
        meta: {
          title: '서비스 레벨 통계'
        },
        component: () =>
          import(/* webpackChunkName: "CallServiceLevelStatistics" */ '@/views/workplace/counselAnalysis/call/CallServiceLevelStatistics') // 분석 -> 콜 상담 분석 -> 서비스 레벨 통계(KT 계정일 경우 노출)
      },
      {
        name: 'call_agent_statistics',
        path: '/report/call_agent_statistics',
        meta: {
          title: '상담사 상태 통계'
        },
        component: () => import(/* webpackChunkName: "CallAgentStatistics" */ '@/views/workplace/counselAnalysis/call/CallAgentStatistics') // 분석 -> 콜 상담 분석 -> 상담사 상태 통계(KT 계정일 경우 노출)
      },
      // 성과 분석
      {
        name: 'consult_evaluate',
        path: '/report/consult_evaluate',
        meta: {
          title: '상담 평가 지표'
        },
        component: () => import(/* webpackChunkName: "ConsultEvaluate" */ '@/views/workplace/counselAnalysis/performance/CounselEvaluate') // 분석 -> 성과 분석 -> 상담 평가 지표
      },
      {
        name: 'consult_quality',
        path: '/report/consult_quality',
        meta: {
          title: '상담 품질 지표'
        },
        component: () => import(/* webpackChunkName: "ConsultQuality" */ '@/views/workplace/counselAnalysis/performance/CounselQuality') // 분석 -> 성과 분석 -> 상담 품질 지표
      },
      // 설문조사 분석
      {
        name: 'survey_report',
        path: '/report/survey_report',
        meta: {
          title: '설문조사 통계'
        },
        component: () => import(/* webpackChunkName: "SurveyReport" */ '@/views/workplace/counselAnalysis/survey/SurveyStatistics') // 분석 -> 설문조사 분석 -> 설문조사 통계
      },
      // 리포트 분석
      {
        name: 'CounReport',
        path: '/report/coun_report',
        meta: {
          title: '데이터 리포트'
        },
        component: () => import(/* webpackChunkName: "CounReport" */ '@/views/workplace/counselAnalysis/report/CounReport') // 분석 -> 리포트 분석 -> 데이터 리포트
      },
      {
        name: 'issue_report',
        path: '/report/issue_report',
        meta: {
          title: '상담 이슈 관리'
        },
        component: () => import(/* webpackChunkName: "IssueReport" */ '@/views/workplace/counselAnalysis/report/IssueReport') // 분석 -> 리포트 분석 -> 상담 이슈 관리
      }
    ]
  },
  {
    name: 'management',
    meta: {
      title: '계정 관리'
    },
    path: '',
    component: routerView,
    children: [
      {
        name: 'MemberManagement',
        path: '/management/member',
        meta: {
          title: '계정 관리',
          requiresBrandKey: false
        },
        component: () => import(/* webpackChunkName: "MemberManagement" */ '@/views/workplace/memberManagement/MemberManagement') // 워크플레이스 > 계정 관리
      },
      {
        name: 'RoleManagement',
        path: '/management/role',
        meta: {
          title: '역할 관리',
          requiresBrandKey: false
        },
        component: () => import(/* webpackChunkName: "RoleManagement" */ '@/views/workplace/memberManagement/RoleManagement') // 계정 관리 -> 역할 관리
      },
      {
        name: 'RoleManagementDetail',
        path: '/management/role/new',
        meta: {
          title: '역할 생성',
          requiresBrandKey: false
        },
        component: () => import(/* webpackChunkName: "RoleManagementDetail" */ '@/views/workplace/memberManagement/RoleManagementDetail') // 계정 관리 -> 역할 생성
      },
      {
        name: 'management_role_modify',
        path: '/management/role/modify',
        meta: {
          title: '역할 수정',
          requiresBrandKey: false
        },
        // component: () => import(/* webpackChunkName: "BrandRoleFormModify" */ '@/views/management/brand/RoleForm') // 계정 관리 -> 역할 수정
        component: () => import(/* webpackChunkName: "RoleManagementDetail" */ '@/views/workplace/memberManagement/RoleManagementDetail') // 계정 관리 -> 역할 생성
      },
      {
        name: 'CounselorHistory',
        path: '/report/agents_status',
        meta: {
          title: '상담사 로그 이력',
          requiresBrandKey: false
        },
        component: () => import(/* webpackChunkName: "CounselorHistory" */ '@/views/workplace/memberManagement/CounselorHistory') // 보안 설정 -> 상담사 로그 이력
      }
    ]
  },
  {
    name: 'CallConsultantSetting',
    path: '/agent/call_consultant_setting',
    meta: {
      title: '콜 내선 번호 관리',
      requiresBrandKey: false
    },
    component: () => import(/* webpackChunkName: "callConsultantSetting" */ '@/views/workplace/callConsultantSetting/CallConsultantSetting') // 콜 내선 번호 관리
  },
  {
    name: 'security',
    path: '',
    meta: {
      title: '보안 설정'
    },
    component: routerView,
    children: [
      {
        name: 'SecuritySetting',
        path: '/brand/security',
        meta: {
          title: '보안 관리',
          requiresBrandKey: false
        },
        component: () => import(/* webpackChunkName: "SecuritySetting" */ '@/views/workplace/security/SecuritySetting') // 보안 설정 -> 보안 관리
      }
    ]
  },
  {
    name: 'brand',
    path: '',
    meta: {
      title: '브랜드 관리'
    },
    component: routerView,
    children: [
      // 기본 설정
      {
        name: 'brand_management',
        path: '/brand/brand_management',
        meta: {
          title: '기본 설정',
          requiresBrandKey: true
        },
        component: () => import(/* webpackChunkName: "BrandManagement" */ '@/views/workplace/brand/basicManagement/BrandManagement'), // 설정 -> 브랜드 설정 -> 기본 설정
        props: getBrandIdentifier
      },
      // 상담 공지
      {
        path: '/notice/list',
        name: 'notice_list',
        meta: {
          title: '상담 공지',
          requiresBrandKey: true
        },
        component: () => import(/* webpackChunkName: "NoticeList" */ '@/views/workplace/brand/basicManagement/Notice'), // 설정 -> 상담 관리 -> 상담 공지
        props: getBrandIdentifier
      },
      {
        path: '/notice/write',
        name: 'notice_write',
        meta: {
          title: '상담 공지 등록',
          requiresBrandKey: true
        },
        component: () => import(/* webpackChunkName: "NoticeRegistration" */ '@/views/workplace/brand/basicManagement/NoticeRegistrationEdit'), // 설정 -> 상담 관리 -> 상담 공지 등록
        props: getBrandIdentifier
      },
      {
        path: '/notice/modify/:id',
        name: 'notice_modify',
        meta: {
          title: '상담 공지 수정',
          requiresBrandKey: true
        },
        component: () => import(/* webpackChunkName: "NoticeModify" */ '@/views/workplace/brand/basicManagement/NoticeRegistrationEdit'), // 설정 -> 상담 관리 -> 상담 공지 수정
        props: getBrandIdentifier
      },
      // 연동 관리
      {
        name: 'channel_systemlink',
        path: '/brand/channel_systemlink',
        meta: {
          title: '채널 연동',
          requiresBrandKey: true
        },
        component: () => import(/* webpackChunkName: "ChannelSystemLink" */ '@/views/workplace/brand/channel/channelSetting/ModuleManagement'), // 브랜드 -> 브랜드 관리 -> 채널 연동
        props: getBrandIdentifier
      },
      {
        name: 'Webchat',
        path: '/brand/channel/webchat',
        meta: {
          title: '웹챗/챗봇',
          requiresBrandKey: true
        },
        component: () => import(/* webpackChunkName: "WebChat" */ '@/views/workplace/brand/channel/channelSetting/WebChat'), // 브랜드 -> 연동 관리 -> 웹챗/챗봇
        props: getBrandIdentifier
      },
      {
        name: 'KakaoTalk',
        path: '/brand/channel/kakaotalk',
        meta: {
          title: '카카오톡 상담톡',
          requiresBrandKey: true
        },
        component: () => import(/* webpackChunkName: "WebChat" */ '@/views/workplace/brand/channel/channelSetting/KakaoTalk'), // 브랜드 -> 연동 관리 -> 카카오톡 상담톡
        props: getBrandIdentifier
      },
      {
        name: 'NaverTalk',
        path: '/brand/channel/navertalk',
        meta: {
          title: '네이버톡톡',
          requiresBrandKey: true
        },
        component: () => import(/* webpackChunkName: "NaverTalk" */ '@/views/workplace/brand/channel/channelSetting/NaverTalk'), // 브랜드 -> 연동 관리 -> 네이버톡톡
        props: getBrandIdentifier
      },
      {
        name: 'Facebook',
        path: '/brand/channel/facebook',
        meta: {
          title: '페이스북 메신저',
          requiresBrandKey: true
        },
        component: () => import(/* webpackChunkName: "Facebook" */ '@/views/workplace/brand/channel/channelSetting/Facebook'), // 브랜드 -> 연동 관리 -> 페이스북
        props: getBrandIdentifier
      },
      {
        name: 'Email',
        path: '/brand/channel/email',
        meta: {
          title: '메일',
          requiresBrandKey: true
        },
        component: () => import(/* webpackChunkName: "Email" */ '@/views/workplace/brand/channel/channelSetting/Email'), // 브랜드 -> 연동 관리 -> 이메일
        props: getBrandIdentifier
      },
      {
        name: 'Sms',
        path: '/brand/channel/sms',
        meta: {
          title: 'SMS',
          requiresBrandKey: true
        },
        component: () => import(/* webpackChunkName: "Sms" */ '@/views/workplace/brand/channel/channelSetting/Sms'), // 브랜드 -> 연동 관리 -> SMS
        props: getBrandIdentifier
      },
      {
        name: 'KakaoInstantMessage',
        path: '/brand/channel/kakao_instant',
        meta: {
          title: '카카오 알림톡',
          requiresBrandKey: true
        },
        component: () => import(/* webpackChunkName: "KakaoInstantMessage" */ '@/views/workplace/brand/channel/channelSetting/KakaoInstantMessage'), // 브랜드 -> 연동 관리 -> 카카오 알림톡
        props: getBrandIdentifier
      },
      {
        name: 'Call',
        path: '/brand/channel/call',
        meta: {
          title: '콜',
          requiresBrandKey: true
        },
        component: () => import(/* webpackChunkName: "Call" */ '@/views/workplace/brand/channel/channelSetting/Call'), // 브랜드 -> 연동 관리 -> 콜
        props: getBrandIdentifier
      },
      {
        name: 'DataInsight',
        path: '/brand/channel/data_insight',
        meta: {
          title: 'DataInsight ',
          requiresBrandKey: true
        },
        component: () => import(/* webpackChunkName: "DataInsight" */ '@/views/workplace/brand/channel/channelSetting/DataInsight'), // 브랜드 -> 연동 관리 -> DataInsight
        props: getBrandIdentifier
      },
      {
        name: 'chat_style_management', // 삭제
        path: '/chatbot/chat_style_management',
        component: () => import(/* webpackChunkName: "ChatStyleManagement" */ '@/components/menus/chatbot/chat_style_management') // 설정 -> 톡 채널 설정 -> 웹챗/챗봇 스타일
      },
      // 챗봇 시나리오
      {
        name: 'ChatbotIntro',
        path: '/chatbot/chatbot_intro',
        meta: {
          title: '챗봇 시나리오',
          requiresBrandKey: true
        },
        component: () => import(/* webpackChunkName: "ChatbotIntro" */ '@/views/workplace/brand/channel/makeChatbot/ChatbotIntro'), // 설정 -> 톡 채널 설정 -> 챗봇 시나리오
        props: getBrandIdentifier
      },
      // 상담 버튼 설치
      {
        name: 'MakeConsultButton',
        path: '/channel/channel_button',
        meta: {
          title: '상담 버튼 설치',
          requiresBrandKey: true
        },
        component: () => import(/* webpackChunkName: "ChannelButton" */ '@/views/workplace/brand/channel/talkButtonSetting/MakeConsultButton'), // 설정 -> 톡 채널 설정 -> 상담 버튼 설치
        props: getBrandIdentifier
      },
      {
        name: 'kakaoChatOpen',
        path: '/kakao/chat/open',
        meta: {
          title: '카카오톡 오픈',
          requiresAuth: false
        },
        component: () => import(/* webpackChunkName: "CreateChannelButton" */ '@/components/menus/channel/kakao/CreateChannelButton'), // 챗봇 카카오톡 오픈
        props: (route) => ({
          plusFriendId: route.query.plusFriendId,
          brandId: route.query.brandId,
          extra: route.query.extra,
          bot: route.query.bot,
          event: route.query.event
        })
      },
      {
        name: 'naverChatOpen',
        path: '/naver/chat/open',
        meta: {
          title: '네이버 톡톡 오픈',
          requiresAuth: false
        },
        component: () => import(/* webpackChunkName: "NaverChatOpen" */ '@/components/menus/channel/naver/NaverChatOpen'), // 챗봇 네이버 톡톡 오픈
        props: (route) => ({
          naverTalkId: route.query.naverTalkId,
          chatRoomId: route.query.chatRoomId
        })
      },
      // 쇼핑몰 연동
      {
        name: 'commerce_management',
        path: '/brand/commerce_management',
        meta: {
          title: '쇼핑몰 연동',
          requiresBrandKey: true
        },
        component: () => import(/* webpackChunkName: "CommerceManagement" */ '@/views/workplace/brand/commerce/CommerceManagement'), // 설정 -> 브랜드 설정 -> 쇼핑몰 연동
        props: getBrandIdentifier
      },
      {
        name: 'smartstore_management',
        path: '/brand/commerce/smartstore',
        meta: {
          title: '스마트 스토어',
          requiresBrandKey: true
        },
        component: () => import(/* webpackChunkName: "SmartStore" */ '@/views/workplace/brand/commerce/SmartStore'), // 설정 -> 브랜드 설정 -> 쇼핑몰 연동
        props: getBrandIdentifier
      },
      {
        name: 'makeshop_management',
        path: '/brand/commerce/makeshop',
        meta: {
          title: '메이크샵',
          requiresBrandKey: true
        },
        component: () => import(/* webpackChunkName: "Makeshop" */ '@/views/workplace/brand/commerce/Makeshop'), // 설정 -> 브랜드 설정 -> 쇼핑몰 연동
        props: getBrandIdentifier
      },
      {
        name: 'cafe24_management',
        path: '/brand/commerce/cafe24',
        meta: {
          title: '카페24',
          requiresBrandKey: true
        },
        component: () => import(/* webpackChunkName: "Cafe24" */ '@/views/workplace/brand/commerce/Cafe24'), // 설정 -> 브랜드 설정 -> 쇼핑몰 연동
        props: getBrandIdentifier
      },
      {
        name: 'companymall_management',
        path: '/brand/commerce/companymall',
        meta: {
          title: '자사몰',
          requiresBrandKey: true
        },
        component: () => import(/* webpackChunkName: "companyMall" */ '@/views/workplace/brand/commerce/CompanyMall'), // 설정 -> 브랜드 설정 -> 쇼핑몰 연동
        props: getBrandIdentifier
      },
      // 설문조사 설정
      {
        name: 'SurveySetting',
        path: '/survey_setting',
        meta: {
          title: '설문조사 설정',
          requiresBrandKey: true
        },
        component: () => import(/* webpackChunkName: "SurveyManagement" */ '@/views/workplace/brand/survey/SurveySetting'),
        props: getBrandIdentifier
      },
      {
        name: 'SurveyStatus',
        path: '/survey_status',
        meta: {
          title: '설문조사 진행상태',
          requiresBrandKey: true
        },
        component: () => import(/* webpackChunkName: "SurveyStatus" */ '@/views/workplace/brand/survey/SurveyStatus'),
        props: getBrandIdentifier
      },
      // 채팅 상담 관리
      {
        path: '/brand/brand_ban_word_management',
        name: 'ManageBanWord',
        meta: {
          title: '금칙어 추가/삭제',
          requiresBrandKey: true
        },
        component: () => import(/* webpackChunkName: "BrandBanWordManagement" */ '@/views/workplace/brand/channel/manageBanWord/ManageBanWord'), // 설정 -> 톡 채널 설정 -> 금칙어 추가/삭제
        props: getBrandIdentifier
      },
      {
        path: '/brand/brand_auto_message',
        name: 'AutoAnswerMessage',
        meta: {
          title: '자동 메시지',
          requiresBrandKey: true
        },
        component: () => import(/* webpackChunkName: "BrandAutoMessage" */ '@/views/workplace/brand/channel/autoAnswerMessage/AutoAnswerMessage'), // 설정 -> 톡 채널 설정 -> 자동 메시지
        props: getBrandIdentifier
      },
      {
        path: '/agent/category_management',
        name: 'category_management',
        meta: {
          title: '상담 분류',
          requiresBrandKey: true
        },
        component: () => import(/* webpackChunkName: "CounselCategory" */ '@/views/workplace/brand/counselManagement/CounselCategory.vue'), // 설정 -> 상담 관리 -> 상담 분류
        props: getBrandIdentifier
      },
      {
        path: '/brand/brand_counsel_distribution_management',
        name: 'brand_counsel_distribution_management',
        meta: {
          title: '상담 배분',
          requiresBrandKey: true
        },
        component: () => import(/* webpackChunkName: "CounselDistribution" */ '@/views/workplace/brand/counselManagement/CounselDistribution'), // 설정 -> 상담 관리 -> 상담 배분
        props: getBrandIdentifier
      },
      {
        path: '/agent/consulting_type',
        name: 'consulting_type',
        meta: {
          title: '상담 유형',
          requiresBrandKey: true
        },
        component: () => import(/* webpackChunkName: "consultingType" */ '@/views/workplace/brand/counselManagement/CounselType'), // 설정 -> 상담 관리 -> 상담 유형
        props: getBrandIdentifier
      },
      {
        path: '/agent/consulting_type/registration',
        name: 'consulting_type_registration',
        meta: {
          title: '상담 유형 등록',
          requiresBrandKey: true
        },
        component: () =>
          import(/* webpackChunkName: "conunselTypeRegistration" */ '@/views/workplace/brand/counselManagement/CounselTypeRegistration'), // 설정 -> 상담 관리 -> 상담 유형 등록
        props: getBrandIdentifier
      },
      {
        path: '/agent/consulting_type/update',
        name: 'consulting_type_update',
        meta: {
          title: '상담 유형 수정',
          requiresBrandKey: true
        },
        component: () => import(/* webpackChunkName: "conunselTypeUpdate" */ '@/views/workplace/brand/counselManagement/CounselTypeEdit'), // 설정 -> 상담 관리 -> 상담 유형 수정
        props: getBrandIdentifier
      },
      {
        path: '/agent/consulting_template',
        name: 'consulting_template',
        meta: {
          title: '상담 템플릿',
          requiresBrandKey: true
        },
        component: () => import(/* webpackChunkName: "counselTemplate" */ '@/views/workplace/brand/counselManagement/CounselTemplate'), // 설정 -> 상담 관리 -> 상담 템플릿
        props: getBrandIdentifier
      },
      {
        path: '/agent/consulting_template/registration',
        name: 'consulting_template_registration',
        meta: {
          title: '상담 템플릿 등록',
          requiresBrandKey: true
        },
        component: () =>
          import(/* webpackChunkName: "CounselTemplateRegistration" */ '@/views/workplace/brand/counselManagement/CounselTemplateRegistrationEdit'), // 설정 -> 상담 관리 -> 상담 템플릿 등록
        props: getBrandIdentifier
      },
      {
        path: '/agent/consulting_template/update',
        name: 'consulting_template_update',
        meta: {
          title: '상담 템플릿 수정',
          requiresBrandKey: true
        },
        component: () =>
          import(/* webpackChunkName: "consultingTemplateUpdate" */ '@/views/workplace/brand/counselManagement/CounselTemplateRegistrationEdit'), // 설정 -> 상담 관리 -> 상담 템플릿 수정
        props: getBrandIdentifier
      },
      // AI 상담 서비스 관리
      {
        path: '/brand/aiCounselAssistance',
        name: 'aiCounselAssistance',
        meta: {
          title: 'AI FAQ 어시스턴트',
          requiresBrandKey: true
        },
        component: () =>
          import(/* webpackChunkName: "aiCounselAssistance" */ '@/views/workplace/brand/aiCounselSetting/aiCounselAssistance/AICounselAssistance'), // 설정 -> AI 상담 서비스 관리 -> AI FAQ 어시스턴트
        props: getBrandIdentifier
      },
      {
        path: '/brand/aiCounselAssistance/edit',
        name: 'aiCounselAssistanceEdit',
        meta: {
          title: 'AI FAQ 어시스턴트 수정',
          requiresBrandKey: true
        },
        component: () =>
          import(
            /* webpackChunkName: "aiCounselAssistance_edit" */ '@/views/workplace/brand/aiCounselSetting/aiCounselAssistance/AICounselAssistanceEdit'
          ), // 설정 -> AI 상담 서비스 관리 -> AI FAQ 어시스턴트 수정
        props: getBrandIdentifier
      },
      {
        name: 'ai_chatbot_setting',
        path: '/brand/ai_chatbot_setting',
        meta: {
          title: 'AI 챗봇 설정',
          requiresBrandKey: true
        },
        component: () => import(/* webpackChunkName: "ai_chatbot_setting" */ '@/views/workplace/brand/aiCounselSetting/AIChatbotSetting'), // 설정 -> AI 상담 서비스 관리 -> AI FAQ 어시스턴트
        props: getBrandIdentifier
      },
      // 콜 상담 관리
      {
        name: 'reservation_management',
        path: '/agent/reservation_management',
        meta: {
          title: '예약 상담',
          requiresBrandKey: true
        },
        component: () =>
          import(/* webpackChunkName: "reservationManagement" */ '@/views/workplace/brand/callCounselManagement/reservation/reservationManagement'), // 설정 -> 콜 상담 관리 -> 예약 상담
        props: getBrandIdentifier
      },
      {
        name: 'reservation_registration',
        path: '/agent/reservation_registration',
        meta: {
          title: '예약 상담 등록',
          requiresBrandKey: true
        },
        component: () =>
          import(
            /* webpackChunkName: "reservationRegistration" */ '@/views/workplace/brand/callCounselManagement/reservation/reservationRegistration'
          ), // 설정 -> 콜 상담 관리 -> 예약 상담 등록
        props: getBrandIdentifier
      },
      {
        path: '/client/claim_information_management',
        name: 'claim_information_management',
        meta: {
          title: '고객 클레임 정보',
          requiresBrandKey: true
        },
        component: () =>
          import(
            /* webpackChunkName: "claimInformationManagement" */ '@/views/workplace/brand/callCounselManagement/claim/claimInformationManagement'
          ), // 설정 -> 콜 상담 관리 -> 고객 클레임 정보
        props: getBrandIdentifier
      },
      {
        path: '/client/claim_information/:pageType',
        name: 'claim_information_update',
        meta: {
          title: '고객 클레임 정보 등록/수정',
          requiresBrandKey: true
        },
        component: () =>
          import(/* webpackChunkName: "claimInformationCreateUpdate" */ '@/views/workplace/brand/callCounselManagement/claim/claimInformationUpdate'), // 설정 -> 콜 상담 관리 -> 고객 클레임 정보 등록/수정
        props: getBrandIdentifier
      },
      {
        path: '/inqury_type_setting',
        name: 'inqury_type_setting',
        meta: {
          title: '문의유형 설정',
          requiresBrandKey: true
        },
        component: () =>
          import(/* webpackChunkName: "inquryTypeSetting" */ '@/views/workplace/brand/callCounselManagement/inquryType/inquryTypeSetting'), // 설정 -> 콜 상담 관리 -> 문의유형 설정
        props: getBrandIdentifier
      },
      {
        path: '/product_and_supplier_management/product',
        name: 'product_management',
        meta: {
          title: '상품',
          requiresBrandKey: true
        },
        component: () => import(/* webpackChunkName: "productManagement" */ '@/views/workplace/brand/NeoPharmCustom/ProductManagement'), // 설정 > 상품/구입처 관리 > 상품
        props: getBrandIdentifier
      },

      {
        path: '/product_and_supplier_management/supplier',
        name: 'supplier_management',
        meta: {
          title: '구입처',
          requiresBrandKey: true
        },
        component: () => import(/* webpackChunkName: "supplierManagement" */ '@/views/workplace/brand/NeoPharmCustom/SupplierManagement'), // 설정 > 상품/구입처 관리 > 구입처
        props: getBrandIdentifier
      },
      {
        path: '/inquiry/recommended_answer',
        name: 'recommended_answer',
        meta: {
          title: '추천 답변',
          requiresBrandKey: true
        },
        component: () => import(/* webpackChunkName: "recommendedAnswer" */ '@/views/workplace/brand/inquiryCounselManagement/recommendedAnswer'), // 설정 > 1:1 문의 상담 관리 > 추천 답변
        props: getBrandIdentifier
      },
      {
        path: '/inquiry/counsel_greeting',
        name: 'counsel_greeting',
        meta: {
          title: '상담 인사말',
          requiresBrandKey: true
        },
        component: () => import(/* webpackChunkName: "counselGreeting" */ '@/views/workplace/brand/inquiryCounselManagement/counselGreeting'), // 설정 > 1:1 문의 상담 관리 > 상담 인사말
        props: getBrandIdentifier
      }
    ]
  },
  {
    name: 'channel_connection',
    path: '/channel/channel_connection',
    meta: {
      title: '카카오톡 상담톡 안내',
      requiresBrandKey: false
    },
    component: () => import(/* webpackChunkName: "ChannelConnection" */ '@/components/menus/channel/channel_connection') // 도움말 -> 도움말 -> 카카오톡 상담톡 안내
  }
];



// WEBPACK FOOTER //
// ./src/router/subRoutes/workplace.js